export type ImageRenditions = '1680' | '1024' | '600' | '480';

export type ImagePathWithRenditions = {
  imagePath: string;
  lastModified: number;
  renditions: Array<string>;
  isDefault?: boolean;
  lazy?: boolean;
  alt?: string;
};
